// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1zUmC","label":"Section_label__1cYVk","contentWrap":"Section_contentWrap__2XNnm","footer":"Section_footer__2Wdr5","footerInner":"Section_footerInner__13BF6"};